import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface IPNewsletterApi {
    createNewsletter: (agent_job_id: string) => Promise<string>
}

export const IPNewsletterApi = Symbol('IPNewsletterApi')

@injectable()
export class IPNewsletterApiImpl extends PsHttpService implements IPNewsletterApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-telecom-api/telecom`,
        }
    }

    createNewsletter(agent_job_id: string) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/tech-report/create_tech_monitor',
            headers: {
                agent_job_id,
            },
        }).then(res => {
            if (!res.status) throw res
            return res.data as unknown as string;
        })
    }
}
